// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConsultationPricing_consultationPricing__6BsGH {
  display: grid;
  gap: 12px;
  min-width: 0;
  font-family: "Sora", system-ui, sans-serif;
  color: #13231D;
}

.ConsultationPricing_consultationPricingHead__SZTtR {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}

.ConsultationPricing_label__vZvrJ {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #6B987D;
}

.ConsultationPricing_consultationPricingHelper__yAQxC {
  margin: 5px 0 0;
  max-width: 680px;
  font-size: 12px;
  line-height: 1.55;
  color: #64736D;
}

.ConsultationPricing_pricingMode__kYKuN {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.ConsultationPricing_pricingModeOption__S6lQH {
  position: relative;
  min-height: 40px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(130, 177, 148, 0.58);
  border-radius: 14px;
  background: transparent;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
}
.ConsultationPricing_pricingModeOption__S6lQH input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.ConsultationPricing_pricingModeOption__S6lQH:hover {
  background: rgba(130, 177, 148, 0.12);
}
.ConsultationPricing_pricingModeOption__S6lQH.ConsultationPricing_isSelected__wFJR7 {
  background: rgba(130, 177, 148, 0.16);
  border-color: #82B194;
  color: #32453B;
}

.ConsultationPricing_pricingPanel__-HqKO {
  display: grid;
  gap: 10px;
  min-width: 0;
}
.ConsultationPricing_pricingPanel__-HqKO[hidden] {
  display: none;
}

.ConsultationPricing_pricingSplitShell__ch0aY, .ConsultationPricing_singlePricingRow__15H\\+W {
  border: 1px solid rgba(16, 25, 21, 0.09);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.34);
}

.ConsultationPricing_pricingSplitShell__ch0aY {
  padding: 12px;
  overflow: visible;
}

.ConsultationPricing_singlePricingRow__15H\\+W {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) 96px minmax(160px, 0.65fr);
  gap: 10px;
  padding: 14px;
  align-items: end;
}

.ConsultationPricing_consultationTypes__qt3Dg {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  align-items: stretch;
}

.ConsultationPricing_consultationTypeCard__MaQdt {
  min-width: 0;
  padding: 16px;
  border: 1px solid rgba(16, 25, 21, 0.09);
  border-radius: 16px;
  background: transparent;
  overflow: visible;
}

.ConsultationPricing_consultationTypeHead__-WlmB {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  min-height: 78px;
  margin-bottom: 12px;
}

.ConsultationPricing_consultationTypeCopy__bzbEz {
  min-width: 0;
}

.ConsultationPricing_consultationTypeTitle__7bf5K {
  margin: 0;
  font-size: 14px;
  line-height: 1.22;
  font-weight: 800;
}

.ConsultationPricing_consultationTypeDesc__a-vPo {
  margin: 4px 0 0;
  font-size: 11px;
  line-height: 1.42;
  color: #64736D;
}

.ConsultationPricing_consultationTypeBadge__t3Oti {
  flex: 0 0 auto;
  min-height: 24px;
  padding: 0 9px;
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  background: rgba(130, 177, 148, 0.1);
  color: #5E806C;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.ConsultationPricing_pricingFields__Qm-HD {
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) minmax(92px, 0.55fr);
  gap: 10px;
  align-items: end;
}

.ConsultationPricing_pricingMiniField__TOG6D {
  display: grid;
  gap: 7px;
  min-width: 0;
}

.ConsultationPricing_pricingMiniLabel__QX6xF {
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: #6E897C;
  font-weight: 800;
}

.ConsultationPricing_pricingValue__-mgmP, .ConsultationPricing_pricingDuration__QEOP2, .ConsultationPricing_pricingCurrency__6Nmlw {
  min-height: 44px;
  padding: 0 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 1px solid rgba(21, 36, 30, 0.08);
  border-radius: 14px;
  background: #fff;
  color: #13231D;
  font-size: 13px;
  font-weight: 600;
}

.ConsultationPricing_pricingValue__-mgmP {
  justify-content: flex-start;
  font-weight: 700;
  white-space: nowrap;
}
.ConsultationPricing_pricingValue__-mgmP input {
  border: none;
  outline: none;
  background: transparent;
  width: 100%;
  font: inherit;
  font-weight: 700;
  color: inherit;
}
.ConsultationPricing_pricingValue__-mgmP input::placeholder {
  color: rgba(19, 35, 29, 0.4);
}
.ConsultationPricing_pricingValue__-mgmP input {
  /* Hide arrows on number input */
}
.ConsultationPricing_pricingValue__-mgmP input::-webkit-outer-spin-button, .ConsultationPricing_pricingValue__-mgmP input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.ConsultationPricing_pricingValue__-mgmP input[type=number] {
  -moz-appearance: textfield;
}

.ConsultationPricing_pricingDuration__QEOP2 {
  white-space: nowrap;
}

.ConsultationPricing_pricingValueCombo__bxc8\\+ {
  position: relative;
  display: grid;
  grid-template-columns: minmax(100px, 1fr) 68px;
  min-height: 44px;
  border: 1px solid rgba(21, 36, 30, 0.08);
  border-radius: 14px;
  background: #fff;
  overflow: visible;
}
.ConsultationPricing_pricingValueCombo__bxc8\\+ .ConsultationPricing_pricingValue__-mgmP {
  min-width: 0;
  min-height: 42px;
  padding: 0 12px;
  border: 0;
  border-radius: 14px 0 0 14px;
  background: transparent;
}
.ConsultationPricing_pricingValueCombo__bxc8\\+ .ConsultationPricing_pricingCurrencyPicker__6kHcu {
  position: relative;
  min-width: 0;
  z-index: 8;
}
.ConsultationPricing_pricingValueCombo__bxc8\\+ .ConsultationPricing_pricingCurrency__6Nmlw {
  min-height: 42px;
  padding: 0 8px;
  border: 0;
  border-left: 1px solid rgba(21, 36, 30, 0.08);
  border-radius: 0 14px 14px 0;
  background: transparent;
  color: #32453B;
  font-size: 11px;
  font-weight: 800;
}

button.ConsultationPricing_pricingDuration__QEOP2, button.ConsultationPricing_pricingCurrency__6Nmlw {
  width: 100%;
  font: inherit;
  cursor: pointer;
  outline: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}
button.ConsultationPricing_pricingDuration__QEOP2:hover, button.ConsultationPricing_pricingDuration__QEOP2[aria-expanded=true], button.ConsultationPricing_pricingDuration__QEOP2:focus-visible, button.ConsultationPricing_pricingCurrency__6Nmlw:hover, button.ConsultationPricing_pricingCurrency__6Nmlw[aria-expanded=true], button.ConsultationPricing_pricingCurrency__6Nmlw:focus-visible {
  border-color: rgba(130, 177, 148, 0.78);
  box-shadow: 0 0 0 3px rgba(130, 177, 148, 0.13);
  background: #fff;
}

.ConsultationPricing_pricingValueCombo__bxc8\\+ button.ConsultationPricing_pricingCurrency__6Nmlw:hover, .ConsultationPricing_pricingValueCombo__bxc8\\+ button.ConsultationPricing_pricingCurrency__6Nmlw[aria-expanded=true], .ConsultationPricing_pricingValueCombo__bxc8\\+ button.ConsultationPricing_pricingCurrency__6Nmlw:focus-visible {
  color: #345443;
  background: rgba(130, 177, 148, 0.1);
  box-shadow: inset 0 0 0 1px rgba(130, 177, 148, 0.35);
}

.ConsultationPricing_pricingCurrencyPicker__6kHcu, .ConsultationPricing_pricingDurationPicker__1t7ux {
  position: relative;
  min-width: 0;
}

.ConsultationPricing_pricingCurrencyMenu__GXbu4, .ConsultationPricing_pricingDurationMenu__eKI\\+Q {
  position: absolute;
  top: calc(100% + 6px);
  z-index: 40;
  padding: 6px;
  border: 1px solid rgba(21, 36, 30, 0.09);
  border-radius: 14px;
  background: #F7F5F1;
  box-shadow: 0 16px 30px rgba(19, 35, 29, 0.12);
}

.ConsultationPricing_pricingCurrencyMenu__GXbu4 {
  right: 0;
  left: auto;
  width: 214px;
  max-width: min(214px, 100vw - 40px);
}

.ConsultationPricing_pricingDurationMenu__eKI\\+Q {
  left: 0;
  right: 0;
  z-index: 30;
}

.ConsultationPricing_pricingCurrencyOptions__6WH0d, .ConsultationPricing_pricingDurationOptions__epQ\\+Q {
  display: grid;
  gap: 2px;
}

.ConsultationPricing_pricingDurationOptions__epQ\\+Q {
  max-height: 220px;
  overflow: auto;
  overscroll-behavior: contain;
}

.ConsultationPricing_pricingCurrencyOption__28TAZ {
  width: 100%;
  min-height: 40px;
  padding: 6px 9px;
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #13231D;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.ConsultationPricing_pricingCurrencyOption__28TAZ strong {
  font-size: 12px;
  font-weight: 800;
}
.ConsultationPricing_pricingCurrencyOption__28TAZ span {
  font-size: 10.5px;
  color: #64736D;
}

.ConsultationPricing_pricingDurationOption__WZasl {
  width: 100%;
  min-height: 36px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #13231D;
  font: inherit;
  font-size: 12px;
  font-weight: 650;
  text-align: left;
  cursor: pointer;
}

.ConsultationPricing_pricingCurrencyOption__28TAZ:hover, .ConsultationPricing_pricingDurationOption__WZasl:hover {
  background: rgba(130, 177, 148, 0.1);
}
.ConsultationPricing_pricingCurrencyOption__28TAZ.ConsultationPricing_isActive__vWJ27, .ConsultationPricing_pricingDurationOption__WZasl.ConsultationPricing_isActive__vWJ27 {
  background: rgba(130, 177, 148, 0.16);
  color: #345443;
  font-weight: 800;
}

.ConsultationPricing_pricingCaret__frzEs {
  color: #64736D;
  font-size: 10px;
  line-height: 1;
}

.ConsultationPricing_pricingNote__66D5r {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin: 0;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(130, 177, 148, 0.055);
  color: #64736D;
  font-size: 11px;
  line-height: 1.5;
}

.ConsultationPricing_pricingNoteMark__GhUy\\+ {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: rgba(130, 177, 148, 0.14);
  color: #5E806C;
  font-size: 11px;
  font-weight: 800;
}

@media (max-width: 820px) {
  .ConsultationPricing_consultationTypes__qt3Dg, .ConsultationPricing_pricingMode__kYKuN {
    grid-template-columns: 1fr;
  }
  .ConsultationPricing_pricingFields__Qm-HD {
    grid-template-columns: 1fr 140px;
  }
  .ConsultationPricing_pricingValueCombo__bxc8\\+ {
    grid-template-columns: minmax(100px, 1fr) 66px;
  }
  .ConsultationPricing_consultationTypeHead__-WlmB {
    min-height: 72px;
  }
}
@media (max-width: 620px) {
  .ConsultationPricing_singlePricingRow__15H\\+W {
    grid-template-columns: 1fr 88px 120px;
  }
}
@media (max-width: 520px) {
  .ConsultationPricing_singlePricingRow__15H\\+W, .ConsultationPricing_pricingFields__Qm-HD {
    grid-template-columns: 1fr;
  }
  .ConsultationPricing_pricingValueCombo__bxc8\\+ {
    grid-template-columns: minmax(110px, 1fr) 68px;
  }
  .ConsultationPricing_pricingSplitShell__ch0aY {
    padding: 10px;
  }
  .ConsultationPricing_consultationTypeHead__-WlmB {
    min-height: 0;
  }
  .ConsultationPricing_pricingCurrencyMenu__GXbu4 {
    width: 100%;
    max-width: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/EditProfileProfessional/components/DataForm/ProfessionalEditForm/ConsultationPricing/ConsultationPricing.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,YAAA;EACA,0CAAA;EACA,cAAA;AACF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AAEF;;AAAA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAGF;;AADA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAIF;;AAFA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAKF;;AAHA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2CAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAMF;AAJE;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;AAMJ;AAHE;EACE,qCAAA;AAKJ;AAFE;EACE,qCAAA;EACA,qBAAA;EACA,cAAA;AAIJ;;AAAA;EACE,aAAA;EACA,SAAA;EACA,YAAA;AAGF;AADE;EACE,aAAA;AAGJ;;AACA;EACE,wCAAA;EACA,mBAAA;EACA,qCAAA;AAEF;;AAAA;EACE,aAAA;EACA,iBAAA;AAGF;;AADA;EACE,aAAA;EACA,mEAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;AAIF;;AAFA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,oBAAA;AAKF;;AAHA;EACE,YAAA;EACA,aAAA;EACA,wCAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAMF;;AAJA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AAOF;;AALA;EACE,YAAA;AAQF;;AANA;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AASF;;AAPA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAUF;;AARA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oCAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAWF;;AATA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;AAYF;;AAVA;EACE,aAAA;EACA,QAAA;EACA,YAAA;AAaF;;AAXA;EACE,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AAcF;;AAZA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAeF;;AAbA;EACE,2BAAA;EACA,gBAAA;EACA,mBAAA;AAgBF;AAdE;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;AAgBJ;AAfI;EACE,4BAAA;AAiBN;AA1BE;EAWE,gCAAA;AAkBJ;AAjBI;EAEE,wBAAA;EACA,SAAA;AAkBN;AAhBI;EACE,0BAAA;AAkBN;;AAdA;EACE,mBAAA;AAiBF;;AAfA;EACE,kBAAA;EACA,aAAA;EACA,8CAAA;EACA,gBAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AAkBF;AAhBE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,4BAAA;EACA,uBAAA;AAkBJ;AAhBE;EACE,kBAAA;EACA,YAAA;EACA,UAAA;AAkBJ;AAhBE;EACE,gBAAA;EACA,cAAA;EACA,SAAA;EACA,6CAAA;EACA,4BAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAkBJ;;AAdA;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,iFAAA;AAiBF;AAfE;EACE,uCAAA;EACA,+CAAA;EACA,gBAAA;AAiBJ;;AAbE;EACE,cAAA;EACA,oCAAA;EACA,qDAAA;AAgBJ;;AAZA;EACE,kBAAA;EACA,YAAA;AAeF;;AAbA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;EACA,mBAAA;EACA,mBAAA;EACA,8CAAA;AAgBF;;AAdA;EACE,QAAA;EACA,UAAA;EACA,YAAA;EACA,mCAAA;AAiBF;;AAfA;EACE,OAAA;EACA,QAAA;EACA,WAAA;AAkBF;;AAhBA;EACE,aAAA;EACA,QAAA;AAmBF;;AAjBA;EACE,iBAAA;EACA,cAAA;EACA,4BAAA;AAoBF;;AAlBA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAqBF;AAnBE;EACE,eAAA;EACA,gBAAA;AAqBJ;AAnBE;EACE,iBAAA;EACA,cAAA;AAqBJ;;AAlBA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAqBF;;AAlBE;EACE,oCAAA;AAqBJ;AAnBE;EACE,qCAAA;EACA,cAAA;EACA,gBAAA;AAqBJ;;AAlBA;EACE,cAAA;EACA,eAAA;EACA,cAAA;AAqBF;;AAnBA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,sCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAsBF;;AApBA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAuBF;;AApBA;EACE;IAAmC,0BAAA;EAwBnC;EAvBA;IAAiB,gCAAA;EA0BjB;EAzBA;IAAqB,8CAAA;EA4BrB;EA3BA;IAAwB,gBAAA;EA8BxB;AACF;AA7BA;EACE;IAAoB,qCAAA;EAgCpB;AACF;AA/BA;EACE;IAAoC,0BAAA;EAkCpC;EAjCA;IAAqB,8CAAA;EAoCrB;EAnCA;IAAqB,aAAA;EAsCrB;EArCA;IAAwB,aAAA;EAwCxB;EAvCA;IAAuB,WAAA;IAAa,eAAA;EA2CpC;AACF","sourcesContent":[".consultationPricing {\n  display: grid;\n  gap: 12px;\n  min-width: 0;\n  font-family: \"Sora\", system-ui, sans-serif;\n  color: #13231D;\n}\n.consultationPricingHead {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 18px;\n}\n.label {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: .14em;\n  text-transform: uppercase;\n  color: #6B987D;\n}\n.consultationPricingHelper {\n  margin: 5px 0 0;\n  max-width: 680px;\n  font-size: 12px;\n  line-height: 1.55;\n  color: #64736D;\n}\n.pricingMode {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n.pricingModeOption {\n  position: relative;\n  min-height: 40px;\n  padding: 0 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(130, 177, 148, .58);\n  border-radius: 14px;\n  background: transparent;\n  font-size: 12px;\n  font-weight: 800;\n  cursor: pointer;\n\n  input {\n    position: absolute;\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  &:hover {\n    background: rgba(130, 177, 148, .12);\n  }\n\n  &.isSelected {\n    background: rgba(130, 177, 148, .16);\n    border-color: #82B194;\n    color: #32453B;\n  }\n}\n\n.pricingPanel {\n  display: grid;\n  gap: 10px;\n  min-width: 0;\n\n  &[hidden] {\n    display: none;\n  }\n}\n\n.pricingSplitShell, .singlePricingRow {\n  border: 1px solid rgba(16, 25, 21, .09);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, .34);\n}\n.pricingSplitShell {\n  padding: 12px;\n  overflow: visible;\n}\n.singlePricingRow {\n  display: grid;\n  grid-template-columns: minmax(0, 1.45fr) 96px minmax(160px, .65fr);\n  gap: 10px;\n  padding: 14px;\n  align-items: end;\n}\n.consultationTypes {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  align-items: stretch;\n}\n.consultationTypeCard {\n  min-width: 0;\n  padding: 16px;\n  border: 1px solid rgba(16, 25, 21, .09);\n  border-radius: 16px;\n  background: transparent;\n  overflow: visible;\n}\n.consultationTypeHead {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  min-height: 78px;\n  margin-bottom: 12px;\n}\n.consultationTypeCopy {\n  min-width: 0;\n}\n.consultationTypeTitle {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.22;\n  font-weight: 800;\n}\n.consultationTypeDesc {\n  margin: 4px 0 0;\n  font-size: 11px;\n  line-height: 1.42;\n  color: #64736D;\n}\n.consultationTypeBadge {\n  flex: 0 0 auto;\n  min-height: 24px;\n  padding: 0 9px;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 999px;\n  background: rgba(130, 177, 148, .10);\n  color: #5E806C;\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: .06em;\n  text-transform: uppercase;\n}\n.pricingFields {\n  display: grid;\n  grid-template-columns: minmax(0, 1.7fr) minmax(92px, .55fr);\n  gap: 10px;\n  align-items: end;\n}\n.pricingMiniField {\n  display: grid;\n  gap: 7px;\n  min-width: 0;\n}\n.pricingMiniLabel {\n  font-size: 9px;\n  text-transform: uppercase;\n  letter-spacing: .12em;\n  color: #6E897C;\n  font-weight: 800;\n}\n.pricingValue, .pricingDuration, .pricingCurrency {\n  min-height: 44px;\n  padding: 0 13px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  border: 1px solid rgba(21, 36, 30, .08);\n  border-radius: 14px;\n  background: #fff;\n  color: #13231D;\n  font-size: 13px;\n  font-weight: 600;\n}\n.pricingValue {\n  justify-content: flex-start;\n  font-weight: 700;\n  white-space: nowrap;\n  \n  input {\n    border: none;\n    outline: none;\n    background: transparent;\n    width: 100%;\n    font: inherit;\n    font-weight: 700;\n    color: inherit;\n    &::placeholder {\n      color: rgba(19, 35, 29, 0.4);\n    }\n    /* Hide arrows on number input */\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n    &[type=number] {\n      -moz-appearance: textfield;\n    }\n  }\n}\n.pricingDuration {\n  white-space: nowrap;\n}\n.pricingValueCombo {\n  position: relative;\n  display: grid;\n  grid-template-columns: minmax(100px, 1fr) 68px;\n  min-height: 44px;\n  border: 1px solid rgba(21, 36, 30, .08);\n  border-radius: 14px;\n  background: #fff;\n  overflow: visible;\n\n  .pricingValue {\n    min-width: 0;\n    min-height: 42px;\n    padding: 0 12px;\n    border: 0;\n    border-radius: 14px 0 0 14px;\n    background: transparent;\n  }\n  .pricingCurrencyPicker {\n    position: relative;\n    min-width: 0;\n    z-index: 8;\n  }\n  .pricingCurrency {\n    min-height: 42px;\n    padding: 0 8px;\n    border: 0;\n    border-left: 1px solid rgba(21, 36, 30, .08);\n    border-radius: 0 14px 14px 0;\n    background: transparent;\n    color: #32453B;\n    font-size: 11px;\n    font-weight: 800;\n  }\n}\n\nbutton.pricingDuration, button.pricingCurrency {\n  width: 100%;\n  font: inherit;\n  cursor: pointer;\n  outline: none;\n  transition: border-color .18s ease, box-shadow .18s ease, background .18s ease;\n\n  &:hover, &[aria-expanded=\"true\"], &:focus-visible {\n    border-color: rgba(130, 177, 148, .78);\n    box-shadow: 0 0 0 3px rgba(130, 177, 148, .13);\n    background: #fff;\n  }\n}\n.pricingValueCombo button.pricingCurrency {\n  &:hover, &[aria-expanded=\"true\"], &:focus-visible {\n    color: #345443;\n    background: rgba(130, 177, 148, .10);\n    box-shadow: inset 0 0 0 1px rgba(130, 177, 148, .35);\n  }\n}\n\n.pricingCurrencyPicker, .pricingDurationPicker {\n  position: relative;\n  min-width: 0;\n}\n.pricingCurrencyMenu, .pricingDurationMenu {\n  position: absolute;\n  top: calc(100% + 6px);\n  z-index: 40;\n  padding: 6px;\n  border: 1px solid rgba(21, 36, 30, .09);\n  border-radius: 14px;\n  background: #F7F5F1;\n  box-shadow: 0 16px 30px rgba(19, 35, 29, .12);\n}\n.pricingCurrencyMenu {\n  right: 0;\n  left: auto;\n  width: 214px;\n  max-width: min(214px, calc(100vw - 40px));\n}\n.pricingDurationMenu {\n  left: 0;\n  right: 0;\n  z-index: 30;\n}\n.pricingCurrencyOptions, .pricingDurationOptions {\n  display: grid;\n  gap: 2px;\n}\n.pricingDurationOptions {\n  max-height: 220px;\n  overflow: auto;\n  overscroll-behavior: contain;\n}\n.pricingCurrencyOption {\n  width: 100%;\n  min-height: 40px;\n  padding: 6px 9px;\n  display: grid;\n  grid-template-columns: 40px minmax(0, 1fr);\n  align-items: center;\n  gap: 8px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: #13231D;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n\n  strong {\n    font-size: 12px;\n    font-weight: 800;\n  }\n  span {\n    font-size: 10.5px;\n    color: #64736D;\n  }\n}\n.pricingDurationOption {\n  width: 100%;\n  min-height: 36px;\n  padding: 0 10px;\n  display: flex;\n  align-items: center;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: #13231D;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 650;\n  text-align: left;\n  cursor: pointer;\n}\n.pricingCurrencyOption, .pricingDurationOption {\n  &:hover {\n    background: rgba(130, 177, 148, .10);\n  }\n  &.isActive {\n    background: rgba(130, 177, 148, .16);\n    color: #345443;\n    font-weight: 800;\n  }\n}\n.pricingCaret {\n  color: #64736D;\n  font-size: 10px;\n  line-height: 1;\n}\n.pricingNote {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  margin: 0;\n  padding: 10px 12px;\n  border-radius: 14px;\n  background: rgba(130, 177, 148, .055);\n  color: #64736D;\n  font-size: 11px;\n  line-height: 1.5;\n}\n.pricingNoteMark {\n  flex: 0 0 auto;\n  width: 18px;\n  height: 18px;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  background: rgba(130, 177, 148, .14);\n  color: #5E806C;\n  font-size: 11px;\n  font-weight: 800;\n}\n\n@media(max-width: 820px) {\n  .consultationTypes, .pricingMode { grid-template-columns: 1fr; }\n  .pricingFields { grid-template-columns: 1fr 140px; }\n  .pricingValueCombo { grid-template-columns: minmax(100px, 1fr) 66px; }\n  .consultationTypeHead { min-height: 72px; }\n}\n@media(max-width: 620px) {\n  .singlePricingRow { grid-template-columns: 1fr 88px 120px; }\n}\n@media(max-width: 520px) {\n  .singlePricingRow, .pricingFields { grid-template-columns: 1fr; }\n  .pricingValueCombo { grid-template-columns: minmax(110px, 1fr) 68px; }\n  .pricingSplitShell { padding: 10px; }\n  .consultationTypeHead { min-height: 0; }\n  .pricingCurrencyMenu { width: 100%; max-width: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"consultationPricing": `ConsultationPricing_consultationPricing__6BsGH`,
	"consultationPricingHead": `ConsultationPricing_consultationPricingHead__SZTtR`,
	"label": `ConsultationPricing_label__vZvrJ`,
	"consultationPricingHelper": `ConsultationPricing_consultationPricingHelper__yAQxC`,
	"pricingMode": `ConsultationPricing_pricingMode__kYKuN`,
	"pricingModeOption": `ConsultationPricing_pricingModeOption__S6lQH`,
	"isSelected": `ConsultationPricing_isSelected__wFJR7`,
	"pricingPanel": `ConsultationPricing_pricingPanel__-HqKO`,
	"pricingSplitShell": `ConsultationPricing_pricingSplitShell__ch0aY`,
	"singlePricingRow": `ConsultationPricing_singlePricingRow__15H+W`,
	"consultationTypes": `ConsultationPricing_consultationTypes__qt3Dg`,
	"consultationTypeCard": `ConsultationPricing_consultationTypeCard__MaQdt`,
	"consultationTypeHead": `ConsultationPricing_consultationTypeHead__-WlmB`,
	"consultationTypeCopy": `ConsultationPricing_consultationTypeCopy__bzbEz`,
	"consultationTypeTitle": `ConsultationPricing_consultationTypeTitle__7bf5K`,
	"consultationTypeDesc": `ConsultationPricing_consultationTypeDesc__a-vPo`,
	"consultationTypeBadge": `ConsultationPricing_consultationTypeBadge__t3Oti`,
	"pricingFields": `ConsultationPricing_pricingFields__Qm-HD`,
	"pricingMiniField": `ConsultationPricing_pricingMiniField__TOG6D`,
	"pricingMiniLabel": `ConsultationPricing_pricingMiniLabel__QX6xF`,
	"pricingValue": `ConsultationPricing_pricingValue__-mgmP`,
	"pricingDuration": `ConsultationPricing_pricingDuration__QEOP2`,
	"pricingCurrency": `ConsultationPricing_pricingCurrency__6Nmlw`,
	"pricingValueCombo": `ConsultationPricing_pricingValueCombo__bxc8+`,
	"pricingCurrencyPicker": `ConsultationPricing_pricingCurrencyPicker__6kHcu`,
	"pricingDurationPicker": `ConsultationPricing_pricingDurationPicker__1t7ux`,
	"pricingCurrencyMenu": `ConsultationPricing_pricingCurrencyMenu__GXbu4`,
	"pricingDurationMenu": `ConsultationPricing_pricingDurationMenu__eKI+Q`,
	"pricingCurrencyOptions": `ConsultationPricing_pricingCurrencyOptions__6WH0d`,
	"pricingDurationOptions": `ConsultationPricing_pricingDurationOptions__epQ+Q`,
	"pricingCurrencyOption": `ConsultationPricing_pricingCurrencyOption__28TAZ`,
	"pricingDurationOption": `ConsultationPricing_pricingDurationOption__WZasl`,
	"isActive": `ConsultationPricing_isActive__vWJ27`,
	"pricingCaret": `ConsultationPricing_pricingCaret__frzEs`,
	"pricingNote": `ConsultationPricing_pricingNote__66D5r`,
	"pricingNoteMark": `ConsultationPricing_pricingNoteMark__GhUy+`
};
export default ___CSS_LOADER_EXPORT___;
